import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";

import { useAlert } from "react-alert";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import { useDispatch, useSelector } from "react-redux";
import {
  getTopicSections,
  deleteTopicSectionData,
} from "../../../actions/adminTopicSectionActions";

import Loader from "../../Loader";

const ListTopicSections = ({ history, match }) => {
  // const [users, setUsersData] = useState({});
  const alert = useAlert();
  const dispatch = useDispatch();

  const currentTopicId = match.params.topicId;

  useEffect(() => {
    dispatch(getTopicSections(currentTopicId));
  }, [dispatch]);

  const handleDeleteTopic = (id) => {
    confirmAlert({
      title: "Confirm to submit",
      message: "Are you sure to do this.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            dispatch(deleteTopicSectionData(id));
            // history.push(`/admin/topics`);
            alert.success("Topic section deleted successfully");
            dispatch(getTopicSections(currentTopicId));
          },
        },
        {
          label: "No",
          onClick: () => alert.success("No data deleted"),
        },
      ],
    });
  };

  const { topicSections, user_loading } = useSelector((state) => state);

  return (
    <Fragment>
      {user_loading ? (
        <Loader />
      ) : (
        <Fragment>
          <div className="content-wrapper">
            <section className="content-header">
              <h1>
                Manage
                <small>Topic Sections</small>
              </h1>
              <ol className="breadcrumb">
                <li>
                  <Link to="/admin">
                    <i className="fa fa-dashboard"></i> Dashboard
                  </Link>
                </li>
                {topicSections.topicSections.length > 0 && (
                  <li>
                    <Link
                      to={`/admin/topics/${topicSections.topicSections[0].subject._id}`}
                    >
                      <i className="fa fa-table"></i> Topics
                    </Link>
                  </li>
                )}
                <li className="active">Topic Sections</li>
              </ol>
            </section>

            <section className="content">
              <div className="row">
                <div className="col-xs-12">
                  <div className="box">
                    <div className="box-header">
                      <h3 className="box-title">Topic Sections</h3>
                      <div className="box-tools">
                        <Link
                          to={`/admin/topic-sections/${currentTopicId}/add`}
                          className="btn btn-success btn-sm"
                        >
                          + Add Section
                        </Link>
                      </div>
                    </div>
                    <div className="box-body table-responsive no-padding">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                           
                            <th>Topic Name</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {topicSections.user_loading ? (
                            <Loader />
                          ) : topicSections.topicSections.length ? (
                            topicSections.topicSections.map((item, index) => (
                              <tr key={item._id}>
                               
                                <td>{item.section_name}</td>
                                <td>
                                  {item.status === true && (
                                    <span className="badge bg-green">
                                      Active
                                    </span>
                                  )}
                                  {item.status === false && (
                                    <span className="badge bg-yellow">
                                      InActive
                                    </span>
                                  )}
                                </td>
                                <td>
                                  <Link
                                    to={`/admin/topic-sections/edit/${item._id}`}
                                    className="btn btn-success btn-sm"
                                    title="Edit"
                                  >
                                    <i className="fa fa-edit"></i>
                                  </Link>
                                  &nbsp;
                                  <a
                                    className="btn btn-danger btn-sm"
                                    title="Delete"
                                    onClick={() => handleDeleteTopic(item._id)}
                                    key={item._id}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </a>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="2">No records found</td>
                            </tr>
                          )}
                        </tbody>
                        <tfoot></tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default ListTopicSections;
